import React, { useEffect, useRef, useState } from "react";
import DataGrid, {
  Column,
  HeaderFilter,
  Grouping,
  GroupPanel,
  Paging,
  Pager,
  SearchPanel,
  LoadPanel,
  Editing,
  Selection,
  Lookup,
  Toolbar,
  Item,
  Position,
  MasterDetail,
  RowDragging,
  ColumnChooser,
  Summary,
  GroupItem,
  Sorting,
  FilterRow,
} from "devextreme-react/data-grid";
import { twMerge } from "tailwind-merge";

const pageSizes = [20, 50, 100];

function Table({
  rowHeight,
  tableRef,
  dataSource,
  columns = [],
  allowColumnReordering = false,
  containerClass = "",
  tableClass = "",
  isHeaderFilter,
  isGrouping,
  isSearch,
  loading,
  visible = true,
  title,
  keyExpr,
  selection,
  defaultSelectedRowKeys,
  edit,
  onSaving,
  pager = true,
  defaultPageSize,
  renderDetail,
  remoteOperations = false,
  rowDragging,
  showRowLines = false,
  focusedRowEnabled = true,
  summary = false,
  isSorting = false,
  isFilter = true,
  ...restProps
}) {
  const dataGrid = useRef(null);
  const Ref = tableRef ? tableRef : dataGrid;
  const [selectedRows, setSelectedRows] = useState(null);

  useEffect(() => {
    if (loading) {
      Ref.current.instance.beginCustomLoading();
    } else {
      Ref.current.instance.endCustomLoading();
    }
  }, [loading]);

  // useEffect(() => {
  //   if (Ref.current) {
  //     Ref.current.instance.option('paging.pageSize', 10);
  //   }
  // }, []);

  // useEffect(() => {
  //   if(selectedRows){
  //     if(onSelectionChanged){
  //       onSelectionChanged(selectedRows)
  //     }
  //   }
  // },[selectedRows])

  const handleSelectionChange = (event) => {
    setSelectedRows(event);
  };

  return (
    <div className={`${containerClass}`} >
      {title}
      <DataGrid
        // components={components}
        rowHeight 
        ref={Ref}
        dataSource={dataSource}
        allowColumnReordering={allowColumnReordering}
        rowAlternationEnabled={false}
        showColumnLines={false}
        showRowLines={true}
        className={twMerge(`w-full max-h-[840px]`, tableClass)}
        visible={visible}
        focusedRowEnabled={focusedRowEnabled}
        keyExpr={keyExpr}
        remoteOperations={remoteOperations}
        onSaving={onSaving}
        hoverStateEnabled={true}
        errorRowEnabled={false}
        filterPanel={{ filterEnabled: true }}
        loadPanel={{
          enabled: true,
          shadingColor: "transparent",
          shading: false,
          showPane: false,
          text: null,
        }}
        // selectedRowKeys={[]}
        {...restProps}
      >
        {isFilter && <FilterRow visible={true} applyFilter={"auto"} />}
        {isSearch && (
          <SearchPanel visible={true} highlightCaseSensitive={true} />
        )}
        {isSorting && <Sorting mode="multiple" />}
        {isGrouping && <GroupPanel visible={true} />}
        {isGrouping && <Grouping autoExpandAll={true} />}
        {isHeaderFilter && <HeaderFilter visible={true} />}
        {selection && <Selection {...selection} />}
        {edit && <Editing {...edit} />}
        {rowDragging && <RowDragging allowReordering={true} {...rowDragging} />}
        {summary && (
          <Summary>
            <GroupItem column="id" summaryType="count" />
          </Summary>
        )}
        {pager ? (
          remoteOperations ? (
            <Pager
              visible={true}
              showPageSizeSelector={true}
              showNavigationButtons={true}
              showInfo={true}
              infoText={(currentPage, totalPage, totalDataCount) =>
                `${totalDataCount} илэрц ${totalPage} хуудас`
              }
            />
          ) : (
            <Pager
              visible={true}
              // allowedPageSizes={pager.pageSize ? pager.pageSize : pageSizes}
              allowedPageSizes={false}
              showPageSizeSelector={true}
              showNavigationButtons={true}
              showInfo={true}
              infoText={(currentPage, totalPage, totalDataCount) =>
                `${totalDataCount} илэрц ${totalPage} хуудас`
              }
              {...pager}
            />
          )
        ) : null}
        <Paging defaultPageSize={defaultPageSize ? defaultPageSize : 100} />
        {renderDetail && <MasterDetail enabled={true} {...renderDetail} />}
        {columns.map((col, i) => {
          if (col.title === "action") {
            return (
              <Column
                {...col}
                caption={col.headerCellRender ? null : col.title}
                dataField={col.dataIndex}
                key={`column-${i}-${col.title}`}
                lookup={
                  col.haveLookup && {
                    dataSource: col.haveLookup.dataSource,
                    valueExpr: col.haveLookup.valueExpr,
                    displayExpr: col.haveLookup.displayExpr,
                  }
                }
                editCellTemplate={col.editCellTemplate}
              ></Column>
            );
          } else {
            return (
              <Column
                groupIndex={col?.group ? i : null}
                group
                {...col}
                caption={col.headerCellRender ? null : col.title}
                dataField={col.dataIndex}
                key={`column-${i}-${col.title}`}
                lookup={
                  col.haveLookup && {
                    dataSource: col.haveLookup.dataSource,
                    valueExpr: col.haveLookup.valueExpr,
                    displayExpr: col.haveLookup.displayExpr,
                  }
                }
                editCellTemplate={col.editCellTemplate}
              ></Column>
            );
          }
        })}
      </DataGrid>
    </div>
  );
}
export default Table;
